import { useMemo } from 'react';

import { TransactionDetailsFragment } from '@occc/graphql';
import { readableDateWithShortTimezone } from '@occc-app/lib/format';
import { sentenceCase } from '@occc-app/lib/strings';
import { TransactionViewItemOptionalColumns } from '@occc-app/routes/Transactions/TransactionView/types';
import { TransactionViewFooter } from '@occc-app/routes/Transactions/TransactionView/TransactionViewFooter';

import { NO_DATA_PLACEHOLDER } from '@occc-app/design-system';
import { TransactionViewHeader } from './TransactionViewHeader';
import { TransactionViewItems } from './TransactionViewItems';
import {
  getTransactionDetailsLocationAddress,
  getTransactionDetailsPayWith,
  getTransactionDetailsSiteId,
  getTransactionDetailsTotal,
  getTransactionDetailsItems,
  getTransactionDetailsTotalDiscount,
} from './utils';

const HIDDEN_COLUMNS: TransactionViewItemOptionalColumns[] = ['group', 'sku', 'upc'];

export const TransactionViewOfTransactionDetails = (props: {
  transaction: TransactionDetailsFragment;
}) => {
  const {
    items: lineItems,
    location,
    createdAt,
    startedAt,
    completedAt,
    authCode,
    primaryStatus,
    tax,
    fuelReceipt,
    paymentInfo,
  } = props.transaction;

  const total = useMemo(() => getTransactionDetailsTotal(lineItems), [lineItems]);

  const discount = useMemo(() => getTransactionDetailsTotalDiscount(lineItems), [lineItems]);

  const items = useMemo(() => {
    return getTransactionDetailsItems(lineItems, fuelReceipt?.product);
  }, [fuelReceipt?.product, lineItems]);

  return (
    <>
      <TransactionViewHeader
        locationId={location?.uuid || ''}
        locationSiteId={getTransactionDetailsSiteId(location)}
        locationAddress={getTransactionDetailsLocationAddress(location)}
        paidWith={getTransactionDetailsPayWith(paymentInfo).toUpperCase()}
        time={readableDateWithShortTimezone(createdAt)}
        startedAt={readableDateWithShortTimezone(startedAt)}
        completedAt={completedAt ? readableDateWithShortTimezone(completedAt) : NO_DATA_PLACEHOLDER}
        authCode={authCode || NO_DATA_PLACEHOLDER}
        status={sentenceCase(primaryStatus)}
        total={total}
        discount={discount}
      />
      <TransactionViewItems items={items} hideColumns={HIDDEN_COLUMNS} />
      <TransactionViewFooter total={total} discount={discount} tax={tax?.price} />
    </>
  );
};
